import { Theme } from "@mui/material";

export const styles = (theme: Theme) => ({
  "&": {
    fontFamily: theme.typography.fontFamily,
    fontSize: "16px",
    padding: "15px 20px",
    border: `2px solid ${theme.palette.common.white}`,
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    justifyContent: "space-between",
  },
  "&:first-of-type": {
    borderTopRightRadius: "30px",
    borderTopLeftRadius: "30px",
  },
  "&:last-of-type": {
    borderBottomRightRadius: "30px",
    borderBottomLeftRadius: "30px",
  },
  "&.MuiListItemButton-gutters": {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
  },
  "&:focus": {
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.primary.main,
    borderWidth: "2px",
  },
  "&:hover": {
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.primary.main,
    borderWidth: "2px",
  },
  "&.Mui-selected": {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white,
  },
  "&.Mui-selected:hover": {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.primary.main,
    borderWidth: "2px",
  },
  "&.Mui-selected:focus": {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.primary.main,
    borderWidth: "2px",
  },
});
